import Swiper from 'swiper/bundle';

const swiperLookBook24 = new Swiper ('.pl24-swiper', {
  slidesPerView: 1,
  spaceBetween: 20,
  mousewheel: true,
  breakpoints: {
    320: {
    navigation: {
      nextEl: '.pl24-anchor_arrow',
      },
      centeredSlides: true,
    },
    768: {
      navigation: {
        nextEl: '.pl24-swiper_arrow',
      },
      spaceBetween: 0,
      centeredSlides: false,
    }
  }
})

const searchingIndexCarouselLookbook = (swiper) => {
  const carouselPageContainer = document.querySelector('.pl24-main_container .swiper-container');
  const url = window.location.href;
  const hasParams = url.indexOf('?');
  const searchParams = new URLSearchParams(window.location.search); 
  const fragment = searchParams.get('ID');
  const carouselItem = document.getElementById(fragment);

  if (searchParams.size > 0 || hasParams !== -1) {
    if (carouselItem) {
      const itemIndex = carouselItem.ariaLabel.split(' ')[0];
      setTimeout(() => {
        swiper.slideTo((itemIndex - 1));
      }, 100);

      swiper.on('slideChangeTransitionEnd', () => {
          carouselPageContainer.style.opacity = 1;
      });

    }
  }else {
    carouselPageContainer.style.opacity = 1;
  }
}

  export const initLookBook24 = () => {
    if (document.querySelector('.pl24-main_container')) {
      searchingIndexCarouselLookbook(swiperLookBook24);
    }
  }